import script from "./Form.vue?vue&type=script&setup=true&lang=js"
export * from "./Form.vue?vue&type=script&setup=true&lang=js"

import "./Form.vue?vue&type=style&index=0&id=9a958328&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3624/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a958328"]])

export default __exports__